import { delay, http, HttpResponse } from 'msw';

export const handlers = [
  http.get('*/sumo/v1/content/favorites', async () => {
    await delay(1500);
    return HttpResponse.json({
      errorMessage: null,
      errorInstanceId: null,
      errorKey: null,
      folder: {
        id: -10,
        parentId: 0,
        name: 'Favorites',
        description: '',
        sharingStatus: 'PRIVATE',
        visibility: 'USER',
        sharerId: 0,
        sharerName: null,
        actions: [],
        permissions: [],
        relativePath: [],
        useViewerRbac: false,
        accessKey: null,
        type: 'folder',
        runAsIdOverride: null,
        originalContentId: 0,
        ownerId: 0,
        ownerName: '',
        createdBy: 'Sumo Logic',
        modifiedBy: 'Sumo Logic',
        createdAt: 0,
        modifiedAt: 0,
        sharedAt: null,
        children: [],
        favorite: false,
        isFavorite: false,
      },
      error: false,
      keyedErrors: [],
    });
  }),
];
